<template>
  <div style="width: 100%; height: 100%;">
    <slot v-bind="slotDataCanvas"></slot>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapState, mapActions, mapGetters } = createNamespacedHelpers("browser");
import { createValidator } from "@/utils/validation.js";
import { createMapper } from "@/utils/mapping.js";

const validator = createValidator("browser");
const mapper = createMapper("browser");

export default {
  props: {
    content: {
      type: Array,
      required: true,
    },
  },
  watch: {
    "$route.query": {
      handler(query) {
        const { textVisible } = validator.clean(mapper.fromURL(query));
        this.setTextVisibility(textVisible);
      },
      immediate: true,
    },
    isTextVisible: {
      handler(value) {
        if (value === false) {
          // make all text invisible
          this.clearSelectedElements();
        } else {
          // make all text visible
          this.flattened.forEach((element) => {
            this.addSelectedElement(element.id);
          });
        }

        // FIXME: do not set url param if value equal to default value anyway

        if (value !== validator.getDefault("textVisible")) {
          this.$router.push({
            ...this.$route,
            query: {
              ...this.$route.query,
              ...mapper.toURL({ textVisible: true }),
            },
          });
        } else {
          const { textVisible, ...query } = mapper.fromURL(this.$route.query);
          this.$router.push({
            ...this.$route,
            ...mapper.toURL(query),
          });
        }
      },
      immediate: true,
    },
    selectedElements: {
      handler(elements) {
        console.log("selectedElements");
        console.log(elements);
        for (var i = 0; i < this.content.length; i++) {
          this.content[i].children.map((element) => {
            if (element) {
              const state = this.elementStates[element.id];
              this.elementStates[i][element.id] = {
                ...this.elementStates[i][element.id],
                isTextVisible: elements.includes(element.id),
              };
            }
          });
        }
      },
      immediate: true,
    },
  },
  data() {
    // FIXME: do highlighting, result snippet parsine here??
    return {
      elementStates: this.makeElementStates(),
      isReady: false,
    };
  },
  computed: {
    ...mapGetters(["isTextVisible"]),
    ...mapState(["selectedElements"]),
    flattened() {
      var flattened = [];
      for (var region in this.statefulElements) {
        var element = this.statefulElements[region];
        var filtered = element.children.filter(function(el) {
          return el != null;
        });
        flattened.push(...filtered);
      }

      return flattened;
    },
    slotDataCanvas() {
      var flattened = [];
      for (var region in this.statefulElements) {
        var element = this.statefulElements[region];
        var filtered = element.children.filter(function(el) {
          return el != null;
        });
        flattened.push(...filtered);
      }

      return {
        handleElementClick: this.handleClick,
        elements: flattened,
      };
    },
    statefulElements() {
      for (var i = 0; i < this.content.length; i++) {
        this.content[i].children = this.content[i].children.map((element) => {
          if (element) {
            element = {
              ...element,
              ...this.elementStates[i][element.id],
            };
            return element;
          }
        });
      }
      return this.content;
    },
  },

  beforeDestroy() {
    this.clearSelectedElements();
  },
  methods: {
    ...mapActions([
      "toggleElementTextVisibility",
      "addSelectedElement",
      "clearSelectedElements",
      "setTextVisibility",
    ]),
    makeElementStates() {
      var temp = [];
      var that = this;
      this.content.forEach(function(region) {
        var filtered = region.children.filter(function(el) {
          return el != null;
        });
        var obj = filtered.reduce(
          (obj, val) => ({
            ...obj,
            [val.id]: {
              isHighlighted: val.highlight,
              isTextVisible: that.isTextVisible,
            },
          }),
          {}
        );
        temp.push(obj);
      });
      return temp;
    },
    handleClick(id) {
      this.toggleElementTextVisibility(id);
    },
  },
};
</script>
